module.exports = __webpack_public_path__ + "img/hr-concrete-hole-decal-05.f52deba1.png";